import React from "react";
import { Link } from "react-router-dom";
import {
  FaMobileAlt,
  FaBatteryHalf,
  FaChargingStation,
  FaCamera,
  FaMicrochip,
  FaTint,
  FaUnlockAlt,
  FaDatabase,
} from "react-icons/fa";

import "./ServicesSection.css";

function ServicesSection({
  badge = "Our Services",
  title = "Complete Mobile Repair Solutions",
  description = "We repair all kinds of hardware and software issues for iPhone, Samsung, Xiaomi, Oppo, Huawei and all major Android devices.",
}) {
  const services = [
    {
      slug: "screen-replacement",
      icon: <FaMobileAlt />,
      title: "Screen Replacement",
      description:
        "Broken, cracked, or damaged screens repaired with high-quality replacement parts.",
    },
    {
      slug: "battery-replacement",
      icon: <FaBatteryHalf />,
      title: "Battery Replacement",
      description:
        "Fast battery replacement for iPhone and Android devices with long-lasting performance.",
    },
    {
      slug: "charging-port-repair",
      icon: <FaChargingStation />,
      title: "Charging Port Repair",
      description:
        "Fix charging issues, loose charging ports, and power connection problems.",
    },
    {
      slug: "camera-repair",
      icon: <FaCamera />,
      title: "Camera Repair",
      description:
        "Front and rear camera repairs including focus, lens, and hardware issues.",
    },
    {
      slug: "motherboard-repair",
      icon: <FaMicrochip />,
      title: "Motherboard Repair",
      description:
        "Advanced chip-level diagnostics and motherboard repairs for complex issues.",
    },
    {
      slug: "water-damage-repair",
      icon: <FaTint />,
      title: "Water Damage Repair",
      description:
        "Professional cleaning and restoration for water-damaged devices.",
    },
    {
      slug: "software-solutions",
      icon: <FaUnlockAlt />,
      title: "Software Solutions",
      description:
        "Software troubleshooting, updates, unlocking, flashing, and bug fixes.",
    },
    {
      slug: "data-recovery",
      icon: <FaDatabase />,
      title: "Data Recovery",
      description:
        "Recover important photos, videos, files, and device data safely.",
    },
  ];

  return (
    <section className="services-section">
      <div className="container">
        <div className="section-heading text-center">
          <span className="section-badge">{badge}</span>

          <h2 className="section-title">{title}</h2>

          <p className="section-description">{description}</p>
        </div>

        <div className="row">
          {services.map((service, index) => (
            <div
              className="col-lg-3 col-md-6 col-12 mb-3"
              key={service.slug}
              data-aos="flip-left"
              data-aos-delay={index * 100}
            >
              <Link
                to={`/services/${service.slug}`}
                className="service-card-link"
              >
                <div className="service-card">
                  <div className="service-icon">{service.icon}</div>

                  <h4>{service.title}</h4>

                  <p>{service.description}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;